




















































import CameraBottomSheet from "@/components/camera/CameraBottomSheet.vue";
import CameraDialog from "@/components/camera/CameraDialog.vue";
import FileExample from "@/components/files/FileExample.vue";
import FileUpload from "@/components/files/FileUpload.vue";
import ImageUploadButton from "@/components/files/ImageUploadButton.vue";
import PdfUploadDialog from "@/components/files/PdfUploadDialog.vue";
import PdfViewer from "@/components/files/PdfViewer.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import ReportImageSubmission from "@/mixins/ReportImageSubmissionMixin.vue";
import { IImageUploaded } from "@/models/Image/IImageUploaded";
import { ReportImageType } from "@/models/Report/ReportImageType";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Prop } from "vue-property-decorator";
@Component({
  components: {
    PdfViewer,
    LayoutReportStep,
    ImageUploadButton,
    FileExample,
    FileUpload,
    CameraDialog,
    CameraBottomSheet,
    PdfUploadDialog
  }
})
/**
 * Uploads images as overview images
 */
export default class ReportImageUpload extends ReportImageSubmission {
  @Prop()
  asset!: AssetEnum;

  @Prop()
  example!: AssetEnum;

  @Prop()
  instruction!: IReportInstructionData;

  @Prop()
  type!: ReportImageType;

  /**
   * @inheritdoc
   */
  get files(): IImageUploaded[] {
    return ReportModule.overviews.filter(image => image.type === this.type);
  }

  /**
   * @inheritdoc
   */
  async handleUpload(file: File): Promise<boolean> {
    await ReportModule.addImage({ file, type: this.type });
    return true;
  }

  /**
   * @inheritdoc
   */
  async handleDelete(file: File): Promise<boolean> {
    await ReportModule.removeImage({ file, type: this.type });
    return true;
  }
}
